module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "AI 智能运维专家 (Agent Mode)",
      "visible": _vm.visible,
      "width": "95%",
      "top": "5vh",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": "",
      "custom-class": "agent-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "agent-container"
  }, [_c('div', {
    staticClass: "agent-stream-panel"
  }, [_c('div', {
    staticClass: "stream-header"
  }, [_c('div', {
    staticClass: "agent-avatar"
  }, [_c('i', {
    staticClass: "el-icon-s-custom",
    staticStyle: {
      "font-size": "24px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "agent-status"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("DevOps Copilot")]), _vm._v(" "), (_vm.isThinking) ? _c('div', {
    staticClass: "status-text"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 思考分析中...\n           ")]) : _c('div', {
    staticClass: "status-text idle"
  }, [_vm._v("\n             就绪\n           ")])])]), _vm._v(" "), _c('div', {
    ref: "streamContent",
    staticClass: "stream-content"
  }, _vm._l((_vm.eventStream), function(event, index) {
    return _c('div', {
      key: index,
      staticClass: "stream-item"
    }, [(event.type === 'thought') ? _c('div', {
      staticClass: "agent-thought"
    }, [_c('div', {
      staticClass: "thought-icon"
    }, [_c('i', {
      staticClass: "el-icon-cpu"
    })]), _vm._v(" "), _c('div', {
      staticClass: "thought-content"
    }, [_vm._v(_vm._s(event.content))])]) : _vm._e(), _vm._v(" "), (event.type === 'message') ? _c('div', {
      staticClass: "agent-message"
    }, [_c('div', {
      staticClass: "message-bubble"
    }, [_vm._v("\n                  " + _vm._s(event.content) + "\n               ")])]) : _vm._e(), _vm._v(" "), (event.type === 'analysis_plan') ? _c('div', {
      staticClass: "agent-plan"
    }, [_c('div', {
      staticClass: "plan-card"
    }, [_c('div', {
      staticClass: "plan-header"
    }, [_c('i', {
      staticClass: "el-icon-document"
    }), _vm._v(" 排查报告\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "plan-body"
    }, [(event.summary) ? _c('div', {
      staticClass: "plan-summary"
    }, [_c('div', {
      staticClass: "plan-section-title"
    }, [_vm._v("结论")]), _vm._v(" "), _c('div', {
      staticClass: "plan-summary-text"
    }, [_vm._v(_vm._s(event.summary))])]) : _vm._e(), _vm._v(" "), (event.trace && event.trace.length) ? _c('div', {
      staticClass: "plan-trace"
    }, [_c('div', {
      staticClass: "plan-section-title"
    }, [_vm._v("排查过程")]), _vm._v(" "), _vm._l((event.trace), function(trace, traceIndex) {
      return _c('div', {
        key: traceIndex,
        staticClass: "trace-item"
      }, [_c('div', {
        staticClass: "trace-index"
      }, [_vm._v(_vm._s(traceIndex + 1))]), _vm._v(" "), _c('div', {
        staticClass: "trace-content"
      }, [(trace.check) ? _c('div', {
        staticClass: "trace-check"
      }, [_vm._v(_vm._s(trace.check))]) : _vm._e(), _vm._v(" "), (trace.evidence) ? _c('div', {
        staticClass: "trace-evidence"
      }, [_vm._v("证据：" + _vm._s(trace.evidence))]) : _vm._e(), _vm._v(" "), (trace.result) ? _c('div', {
        staticClass: "trace-result"
      }, [_vm._v("结论：" + _vm._s(trace.result))]) : _vm._e()])])
    })], 2) : _vm._e(), _vm._v(" "), _vm._l((event.steps), function(step, stepIndex) {
      return _c('div', {
        key: stepIndex,
        staticClass: "step-item"
      }, [_c('div', {
        staticClass: "step-num"
      }, [_vm._v(_vm._s(stepIndex + 1))]), _vm._v(" "), _c('div', {
        staticClass: "step-content"
      }, [(step.title) ? _c('div', {
        staticClass: "step-title"
      }, [_vm._v(_vm._s(step.title))]) : _vm._e(), _vm._v(" "), (step.command) ? _c('div', {
        staticClass: "step-cmd"
      }, [_c('code', [_vm._v(_vm._s(step.command))]), _vm._v(" "), _c('div', {
        staticClass: "step-actions"
      }, [_c('el-button', {
        attrs: {
          "size": "mini",
          "type": "primary",
          "disabled": !_vm.isConnected
        },
        on: {
          "click": function($event) {
            return _vm.runStepCommand(step)
          }
        }
      }, [_vm._v("\n                                  执行\n                                ")])], 1)]) : _vm._e(), _vm._v(" "), (step.description) ? _c('div', {
        staticClass: "step-desc"
      }, [_vm._v(_vm._s(step.description))]) : _vm._e()])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (event.type === 'tool_call') ? _c('div', {
      staticClass: "agent-action"
    }, [_c('div', {
      staticClass: "action-card"
    }, [_c('div', {
      staticClass: "action-header"
    }, [_c('i', {
      staticClass: "el-icon-monitor"
    }), _vm._v(" 执行指令\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "action-code"
    }, [_c('code', [_vm._v(_vm._s(event.input))])]), _vm._v(" "), _c('div', {
      staticClass: "action-status"
    }, [(event.status === 'pending') ? _c('span', {
      staticClass: "status-pending"
    }, [_c('i', {
      staticClass: "el-icon-time"
    }), _vm._v(" 待执行")]) : _vm._e(), _vm._v(" "), (event.status === 'running') ? _c('span', {
      staticClass: "status-running"
    }, [_c('i', {
      staticClass: "el-icon-loading"
    }), _vm._v(" 执行中...")]) : _vm._e(), _vm._v(" "), (event.status === 'success') ? _c('span', {
      staticClass: "status-success"
    }, [_c('i', {
      staticClass: "el-icon-check"
    }), _vm._v(" 完成")]) : _vm._e(), _vm._v(" "), (event.status === 'failed') ? _c('span', {
      staticClass: "status-failed"
    }, [_c('i', {
      staticClass: "el-icon-close"
    }), _vm._v(" 失败")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "action-actions"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "disabled": !event.input || !_vm.isConnected || !_vm._isShellTool(event.tool)
      },
      on: {
        "click": function($event) {
          return _vm.runToolCommand(event)
        }
      }
    }, [_vm._v("\n                       执行\n                     ")])], 1)])]) : _vm._e(), _vm._v(" "), (event.type === 'tool_output') ? _c('div', {
      staticClass: "agent-tool-output"
    }, [_c('div', {
      staticClass: "output-header"
    }, [_c('i', {
      staticClass: "el-icon-document"
    }), _vm._v(" Output\n               ")]), _vm._v(" "), _c('pre', {
      staticClass: "output-body"
    }, [_vm._v(_vm._s(event.content))])]) : _vm._e(), _vm._v(" "), (event.type === 'user_input') ? _c('div', {
      staticClass: "user-input-message"
    }, [_c('div', {
      staticClass: "message-bubble user"
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" " + _vm._s(event.content) + "\n               ")])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.isPaused ? 'Paused. Press Esc to resume...' : 'Human instruction (Enter to send, Esc to pause)...',
      "disabled": !_vm.canTypeUserMessage
    },
    nativeOn: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendUserMessage($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.togglePause($event)
      }]
    },
    model: {
      value: (_vm.userInput),
      callback: function($$v) {
        _vm.userInput = $$v
      },
      expression: "userInput"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-s-promotion",
      "disabled": !_vm.userInput.trim() || !_vm.canSendUserMessage
    },
    on: {
      "click": _vm.sendUserMessage
    },
    slot: "append"
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "terminal-panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-s-platform"
  }), _vm._v(" 实时终端 (" + _vm._s(_vm.alertInfo.hostip || 'Server') + ")")]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [(_vm.isConnected) ? _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "success"
    }
  }, [_vm._v("已连接")]) : _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "info"
    }
  }, [_vm._v("未连接")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "terminal-wrapper"
  }, [_c('shell_term', {
    ref: "shellTerm",
    attrs: {
      "init_token": _vm.shellToken,
      "show_type": "0"
    }
  }), _vm._v(" "), (!_vm.isConnected && !_vm.shellToken) ? _c('div', {
    staticClass: "terminal-overlay"
  }, [_c('div', {
    staticClass: "overlay-content"
  }, [_vm._v("等待 Agent 连接服务器...")])]) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-452eebcb","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common_page/AiAnalysisDialog.vue
// module id = CzXy
// module chunks = 81